import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Colours", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-error" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-error" }, "error")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-success" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-success" }, "success")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-danger" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-danger" }, "danger")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Base", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-base-light block border border-solid border-cebai-base-dark" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-base-light" }, "light"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-base-dark" }, "(light)")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-base-dark" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-base-dark" }, "dark")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Primary", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-primary" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-primary" }, "primary")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Grey", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-lightest" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-lightest" }, [
      /*#__PURE__*/_createTextVNode("lightest "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-base-dark" }, "(lightest)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-lighter" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-lighter" }, [
      /*#__PURE__*/_createTextVNode("lighter "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-base-dark" }, "(lighter)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-light" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-light" }, "light")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-mid" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-light" }, "mid")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-dark" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark" }, "dark")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "mr-2 w-6 h-6 bg-cebai-grey-darker" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text-cebai-grey-dark" }, "darker")
  ])
], -1)
const _hoisted_13 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Alerts (click to see)", -1)
const _hoisted_15 = { class: "md:flex mb-6" }
const _hoisted_16 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Buttons", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "my-2" }, "Components", -1)
const _hoisted_19 = { class: "flex flex-wrap mb-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Types", -1)
const _hoisted_21 = { class: "flex flex-wrap mb-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Disabled", -1)
const _hoisted_24 = { class: "flex flex-wrap items-center mb-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Button with text and icon", -1)
const _hoisted_27 = { class: "flex flex-wrap items-center mb-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Button with icon only", -1)
const _hoisted_29 = { class: "flex flex-wrap items-center mb-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Button with loading state", -1)
const _hoisted_32 = { class: "flex items-center mb-6" }
const _hoisted_33 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Toggle", -1)
const _hoisted_35 = { class: "w-60 md:w-[25em]" }
const _hoisted_36 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Form inputs", -1)
const _hoisted_38 = { class: "mb-10" }
const _hoisted_39 = { class: "label" }
const _hoisted_40 = { class: "mb-10" }
const _hoisted_41 = { class: "label" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "mb-10" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "mb-10" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", {
  style: {"font-family":"sans-serif"},
  value: ""
}, "All", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "mb-10" }
const _hoisted_50 = { class: "label" }
const _hoisted_51 = { class: "mb-10" }
const _hoisted_52 = { class: "label" }
const _hoisted_53 = { class: "mb-10" }
const _hoisted_54 = { class: "label" }
const _hoisted_55 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Modal content", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", null, "Some modal content...", -1)
const _hoisted_58 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Editorial", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h1", null, "h1", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h2", null, "h2", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h3", null, "h3", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h4", null, "h4", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h5", null, "h5", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h6", null, "h6", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("p", null, "p", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias ipsum tenetur assumenda! Quaerat quia a rerum tenetur repellendus assumenda vero, fugiat vel similique hic nulla explicabo repudiandae. Hic, amet earum. ", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "lorem"),
  /*#__PURE__*/_createElementVNode("li", null, "ipsum")
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias ipsum tenetur assumenda! Quaerat quia a rerum tenetur repellendus assumenda vero, fugiat vel similique hic nulla explicabo repudiandae. Hic, amet earum. ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "lorem"),
  /*#__PURE__*/_createElementVNode("li", null, "ipsum")
], -1)
const _hoisted_71 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Editorial - centred", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h1", null, "h1", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", null, "h2", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h3", null, "h3", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("h4", null, "h4", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Alias ipsum tenetur assumenda! Quaerat quia a rerum tenetur repellendus assumenda vero, fugiat vel similique hic nulla explicabo repudiandae. Hic, amet earum. ", -1)
const _hoisted_78 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "SVGs", -1)
const _hoisted_80 = { class: "flex flex-wrap items-center justify-center" }
const _hoisted_81 = { class: "text-cebai-primary mr-3" }
const _hoisted_82 = { class: "text-cebai-primary mr-3" }
const _hoisted_83 = { class: "mr-3" }
const _hoisted_84 = { class: "mr-3" }
const _hoisted_85 = { class: "mr-3" }
const _hoisted_86 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - default styling", -1)
const _hoisted_88 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs with SVG images", -1)
const _hoisted_90 = { class: "mr-2" }
const _hoisted_91 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - underlined (and responsive)", -1)
const _hoisted_93 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - buttons (and responsive)", -1)
const _hoisted_95 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - outlined (and responsive)", -1)
const _hoisted_97 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - centred", -1)
const _hoisted_99 = { class: "mr-2" }
const _hoisted_100 = { class: "text-center" }
const _hoisted_101 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Tabs - responsive, centred and outlined", -1)
const _hoisted_103 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("p", { class: "my-6" }, "Markdown", -1)
const _hoisted_105 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Loading icon", -1)
const _hoisted_107 = { class: "mb-6" }
const _hoisted_108 = {
  key: 0,
  class: "flex h-6 w-32"
}
const _hoisted_109 = { key: 1 }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("p", null, "Content is loaded!", -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "mb-12 pb-12 border-b-8 border-cebai-grey-dark" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "Sentry error logging test", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "That's it, for now")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonLink = _resolveComponent("AppButtonLink")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_PlaceholderSvgImage = _resolveComponent("PlaceholderSvgImage")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_AutoResizeTextarea = _resolveComponent("AutoResizeTextarea")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabContent = _resolveComponent("TabContent")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_AppContent = _resolveComponent("AppContent")!

  return (_openBlock(), _createBlock(_component_AppContent, null, {
    default: _withCtx(() => [
      _createVNode(_component_ContentBlock, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "outline",
                onClick: _ctx.addInfo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Info message ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "outline",
                onClick: _ctx.addSuccess
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Success message ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "outline",
                onClick: _ctx.addError
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Error message ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("AppButton")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButtonLink, {
                class: "m-1",
                type: "primary",
                href: "#"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" AppButtonLink ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButtonRouterLink, {
                class: "m-1",
                type: "primary",
                to: { name: 'component-library' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" AppButtonRouterLink ")
                ]),
                _: 1
              })
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Primary")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Secondary")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "outline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Outline")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Text")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                class: "m-1",
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Danger")
                ]),
                _: 1
              })
            ]),
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_AppButton, {
                type: "primary",
                class: "m-1",
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Primary ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "secondary",
                class: "m-1",
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Secondary ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "outline",
                class: "m-1",
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Outline ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "text",
                class: "m-1",
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Text ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "danger",
                class: "m-1",
                disabled: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Danger ")
                ]),
                _: 1
              })
            ]),
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_AppButton, {
                type: "primary",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current ml-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Primary ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "secondary",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current ml-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Secondary ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "outline",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current ml-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Outline ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "text",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current ml-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Text ")
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "danger",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current ml-2" })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Danger ")
                ]),
                _: 1
              })
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_AppButton, {
                type: "primary",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current" })
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "secondary",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current" })
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "outline",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current" })
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "text",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current" })
                ]),
                _: 1
              }),
              _createVNode(_component_AppButton, {
                type: "danger",
                class: "m-1"
              }, {
                iconAfter: _withCtx(() => [
                  _createVNode(_component_PlaceholderSvgImage, { class: "w-5 h-5 fill-current" })
                ]),
                _: 1
              })
            ]),
            _hoisted_30,
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_AppButton, {
                type: "primary",
                class: "m-1",
                "is-loading": _ctx.isLoadingButton,
                onClick: _ctx.handleLoadingButton
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" AppButton with loading state ")
                ]),
                _: 1
              }, 8, ["is-loading", "onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_Toggle, {
                modelValue: _ctx.toggleOne,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.toggleOne) = $event)),
                label: "Update something"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Toggle, {
                modelValue: _ctx.toggleTwo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toggleTwo) = $event)),
                label: "Update something else",
                "help-text": "Here is some help text"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Toggle, {
                modelValue: _ctx.toggleThree,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toggleThree) = $event)),
                label: "Update something with a really long title that wraps onto a second line",
                "help-text": "Here is some really long help text that wraps onto a second line"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Toggle, {
                modelValue: _ctx.toggleFour,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.toggleFour) = $event)),
                label: "Toggle with labels",
                "help-text": "Some more help text",
                "unselected-label": "No",
                "selected-label": "Yes"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, [
                  _createTextVNode(" Toggle 1 value: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.toggleOne), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Toggle 2 value: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.toggleTwo), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Toggle 3 value: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.toggleThree), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Toggle 4 value: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.toggleFour), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _createTextVNode(" Text input (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.inputTextValue), 1),
                _createTextVNode(" ) ")
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputTextValue) = $event)),
                type: "text",
                class: "input",
                placeholder: "Text input"
              }, null, 512), [
                [_vModelText, _ctx.inputTextValue]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, [
                _createTextVNode(" Textarea input - fixed height (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.textareaFixedValue), 1),
                _createTextVNode(" ) ")
              ]),
              _createElementVNode("textarea", {
                rows: "3",
                placeholder: "Textarea input",
                class: "input",
                value: _ctx.textareaFixedValue,
                onInput: _cache[5] || (_cache[5] = 
              (event) =>
                (_ctx.textareaFixedValue = (
                  event.currentTarget as HTMLTextAreaElement
                ).value)
            )
              }, null, 40, _hoisted_42)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, [
                _createTextVNode(" Textarea input - resizeable height (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.textareaResizeableValue), 1),
                _createTextVNode(" ) ")
              ]),
              _createVNode(_component_AutoResizeTextarea, {
                ref: "resizeableTextarea",
                modelValue: _ctx.textareaResizeableValue,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.textareaResizeableValue) = $event)),
                rows: 3,
                "max-rows": 5,
                placeholder: "Textarea input",
                class: "input"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, [
                _createTextVNode(" Select input (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.selectValue), 1),
                _createTextVNode(" ) ")
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectValue) = $event)),
                class: "input mr-2"
              }, [
                _hoisted_47,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    style: {"font-family":"sans-serif"},
                    value: option
                  }, _toDisplayString(option), 9, _hoisted_48))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectValue]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", _hoisted_50, [
                _createTextVNode(" MultiSelect input (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.multiselectValue), 1),
                _createTextVNode(" ) ")
              ]),
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.multiselectValue,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.multiselectValue) = $event)),
                searchable: true,
                options: _ctx.multiselectOptions
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, [
                _createTextVNode(" MultiSelect input with tags (values: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.multiselectTagValues), 1),
                _createTextVNode(" ) ")
              ]),
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.multiselectTagValues,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.multiselectTagValues) = $event)),
                mode: "tags",
                "no-options-text": "Add new keywords and press enter",
                "no-results-text": "Add new keywords and press enter",
                searchable: true,
                "create-tag": true,
                options: _ctx.multiselectTagOptions
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("label", _hoisted_54, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkboxValue) = $event)),
                  type: "checkbox",
                  class: "input"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.checkboxValue]
                ]),
                _createTextVNode(" Checkbox (value: "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.checkboxValue), 1),
                _createTextVNode(" ) ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createVNode(_component_AppButton, {
              type: "primary",
              class: "mb-2 mr-2",
              onClick: _cache[11] || (_cache[11] = () => _ctx.showModal('exampleModal'))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Show modal ")
              ]),
              _: 1
            }),
            _createVNode(_component_Modal, {
              modelValue: _ctx.isShown.exampleModal,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isShown.exampleModal) = $event)),
              close: () => _ctx.closeModal('exampleModal')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ModalContent, {
                  close: () => _ctx.closeModal('exampleModal'),
                  title: "Modal content title"
                }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                }, 8, ["close"])
              ]),
              _: 1
            }, 8, ["modelValue", "close"])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_60,
                _hoisted_61,
                _hoisted_62,
                _hoisted_63,
                _hoisted_64,
                _hoisted_65,
                _hoisted_66,
                _hoisted_67,
                _hoisted_68,
                _hoisted_69,
                _hoisted_70
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_71, [
            _hoisted_72,
            _createVNode(_component_Editorial, { align: "centre" }, {
              default: _withCtx(() => [
                _hoisted_73,
                _hoisted_74,
                _hoisted_75,
                _hoisted_76,
                _hoisted_77
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_PlaceholderSvgImage, { class: "w-24 h-24" }),
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-24 h-24 stroke-current" })
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-24 h-24 fill-current stroke-current" })
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-24 h-24 text-cebai-primary fill-current" })
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-24 h-24 text-cebai-primary stroke-current" })
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-12 h-12" })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_PlaceholderSvgImage, { class: "w-36 h-36" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _hoisted_87,
            _createVNode(_component_Tabs, { "active-tab": _ctx.activeTab }, {
              tabs: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, "Tab " + _toDisplayString(index + 1), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab"])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createVNode(_component_Tabs, { "active-tab": _ctx.activeTab }, {
              tabs: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_PlaceholderSvgImage, { class: "w-4 h-4 fill-current" })
                      ]),
                      _createElementVNode("p", null, "Tab " + _toDisplayString(index + 1), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab"])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createVNode(_component_Tabs, {
              "tab-type": "underlined",
              "active-tab": _ctx.activeTab,
              tabs: _ctx.tabs
            }, {
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab", "tabs"])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _createVNode(_component_Tabs, {
              "tab-type": "button",
              "active-tab": _ctx.activeTab,
              tabs: _ctx.tabs
            }, {
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab", "tabs"])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _hoisted_96,
            _createVNode(_component_Tabs, {
              "tab-type": "outlined",
              "active-tab": _ctx.activeTab,
              tabs: _ctx.tabs
            }, {
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab", "tabs"])
          ]),
          _createElementVNode("div", _hoisted_97, [
            _hoisted_98,
            _createVNode(_component_Tabs, {
              centred: true,
              "active-tab": _ctx.activeTab
            }, {
              tabs: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(_component_PlaceholderSvgImage, { class: "w-4 h-4 fill-current" })
                      ]),
                      _createElementVNode("p", null, "Tab " + _toDisplayString(index + 1), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_100, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab"])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _hoisted_102,
            _createVNode(_component_Tabs, {
              "tab-type": "outlined",
              centred: true,
              "active-tab": _ctx.activeTab,
              tabs: _ctx.tabs
            }, {
              "tab-content": _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabContent, {
                    key: tab.slug,
                    slug: tab.slug
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["slug"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active-tab", "tabs"])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _hoisted_104,
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _createVNode(_component_Markdown, { source: _ctx.markdownContent }, null, 8, ["source"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _createElementVNode("div", _hoisted_107, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                    _createVNode(_component_LoadingIcon, { class: "mr-2" }),
                    _createVNode(_component_LoadingIcon, {
                      class: "mr-2",
                      color: "orange"
                    }),
                    _createVNode(_component_LoadingIcon, { class: "text-cebai-success" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_111))
            ]),
            _createVNode(_component_AppButton, {
              type: "primary",
              onClick: _ctx.toggleLoadingState
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Toggle loading state ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _hoisted_113,
            _createVNode(_component_AppButton, {
              type: "primary",
              onClick: _ctx.throwSentryError
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Throw error ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _hoisted_114
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}